import { Image as BaseImage } from "@chakra-ui/react";

export default BaseImage;
